import SetPasswordCard from './setPasswordCard'

export default SetPasswordCard